import { useCallback, useRef } from "react";
function useRefEffect(effect) {
  const cleanupRef = useRef(void 0);
  return useCallback(
    (instance) => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = void 0;
      }
      if (instance != null) {
        cleanupRef.current = effect(instance);
      }
    },
    [effect]
  );
}
export {
  useRefEffect as default
};
//# sourceMappingURL=useRefEffect.js.map
